function formatErrorMessage(message, errorCode) {
    return errorCode
        ? `${message}. For more information and steps for solving, visit https://motion.dev/troubleshooting/${errorCode}`
        : message;
}

export { formatErrorMessage };
//# sourceMappingURL=format-error-message.mjs.map
